export default class StandardPhase {
  constructor(phaseData) {
    this.uuid = phaseData.uuid;
    this.name = phaseData.name;
    this.status = phaseData.status;
    this.documents = phaseData.documents;
    this.receivedDate = phaseData.receivedDate;
    this.revisedDate = phaseData.revisedDate;
    this.approvedDate = phaseData.approvedDate;
    this.comments = phaseData.comments;
  }

  get getUuid() {
    return this.uuid;
  }

  get getName() {
    return this.name;
  }

  get getStatus() {
    return this.status;
  }

  get getDocuments() {
    return this.documents;
  }

  get getReceivedDate() {
    return this.receivedDate;
  }

  get getRevisedDate() {
    return this.revisedDate;
  }

  get getApprovedDate() {
    return this.approvedDate;
  }

  get getComments() {
    return this.comments;
  }
}
